import React from "react";
import {Box, Checkbox, FormControlLabel, Typography} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {UserInputSettings} from "../settings/components/user-input-settings";
import {WatchdogSelection} from "../settings/WatchdogSelection";


export const VoiceParametersTab = ({node, setNode, onUpdate, project, nodes}) => {

    const onChangeData = (key, value) => {
        setNode(prev => {
            const state = {...prev};
            state.data[key] = value;
            return state;
        })
    }

    const {primary, secondary} = menuItemsInfo.voice_parameters;

    return (
        <>
            <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
                <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
                <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
            </Box>

            <Box sx={{px: 1}}>
                <FormControlLabel
                    size={"small"}
                    control={(
                        <Checkbox checked={!!node?.data?.music_on_hold} size={"small"} sx={{p: 0.5}}
                                  onChange={(event) => {
                                      const checked = event.target.checked;
                                      const nextState = {
                                          ...node,
                                          data: {
                                              ...node.data,
                                              music_on_hold: checked,
                                              please_wait_message: checked ? "audio3s" : null,
                                          },
                                      };
                                      setNode(nextState);
                                      onUpdate(nextState);
                                  }}/>
                    )} label={`Music on Hold`}
                />
            </Box>

            <UserInputSettings node={node} onUpdate={onUpdate} onChangeData={onChangeData}/>

            <WatchdogSelection
                node={node} setNode={setNode}
                onUpdate={onUpdate} onChangeData={onChangeData}
                project={project} nodes={nodes}
            />
        </>
    )
}